<template>
  <header id="ign-header" class="ign-header" role="navigation" :class="isFullWidth ? 'ign-header__full-width' : ''">
    <!-- Mask for the Screen -->
    <div
      class="ign-header__mask"
      :class="isPanelNavigationOpen ? 'ign-header__mask--open' : ''"
    ></div>
    <!-- Header Container -->
    <div class="ign-header__container" :class="isFullWidth ? 'ign-header__container__full-width' : ''">
      <!-- Header Maersk Logo -->
      <a href="/" class="ign-header__logo ign-track">
        <svg
          class="ign-logo"
          viewBox="0 0 170 38"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Large---1280px-(Max-Width)"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="IGN---Transparent"
              transform="translate(-104.000000, -21.000000)"
            >
              <g id="IGN">
                <g id="Logo" transform="translate(104.000000, 21.000000)">
                  <g
                    id="Text"
                    transform="translate(51.502463, 9.973333)"
                    fill="#FFFFFF"
                  >
                    <polyline
                      id="Fill-4"
                      class="ign-logo__fill"
                      points="0.225647399 17.0377015 0.225647399 0.584446483 4.63718082 0.584446483 10.2269671 12.8797823 15.7337777 0.584446483 19.9599991 0.584446483 19.9599991 17.0377015 16.3222127 17.0377015 16.3222127 7.46604648 12.1250328 17.0377015 8.24730872 17.0377015 3.99619469 7.51820061 3.99619469 17.0377015 0.225647399 17.0377015"
                    />
                    <path
                      id="Fill-5"
                      class="ign-logo__fill"
                      d="M34.599652,10.6673492 L31.5558322,3.69310703 L28.5818502,10.6673492 L34.599652,10.6673492 Z M25.8609436,17.0377015 L21.5828626,17.0377015 L28.9365707,0.584446483 L34.2034438,0.584446483 L41.6097031,17.0377015 L37.386939,17.0377015 L35.9293352,13.7602263 L27.2736024,13.7602263 L25.8609436,17.0377015 L25.8609436,17.0377015 Z"
                    />
                    <polyline
                      id="Fill-6"
                      class="ign-logo__fill"
                      points="43.3155421 17.0377015 43.3155421 0.584446483 59.1445112 0.584446483 59.1445112 3.87427401 47.1386406 3.87427401 47.1386406 7.1421419 57.432449 7.1421419 57.432449 10.353052 47.1386406 10.353052 47.1386406 13.7465015 59.1735527 13.7465015 59.1735527 17.0377015 43.3155421 17.0377015"
                    />
                    <path
                      id="Fill-7"
                      class="ign-logo__fill"
                      d="M66.1296696,8.13924648 L74.4465856,8.13924648 L74.4465856,3.87427401 L66.1296696,3.87427401 L66.1296696,8.13924648 Z M62.252637,17.0377015 L62.252637,0.584446483 L75.4983007,0.584446483 C77.2677543,0.584446483 78.2952682,1.60076575 78.2952682,3.34381162 L78.2952682,8.871463 C78.2952682,10.143063 77.1605776,11.2925125 74.961034,11.2925125 C74.8365707,11.2986887 74.7093415,11.2925125 74.578655,11.2925125 L78.4342523,17.0377015 L74.1789895,17.0377015 L70.523225,11.411918 L66.1296696,11.411918 L66.1296696,17.0377015 L62.252637,17.0377015 L62.252637,17.0377015 Z"
                    />
                    <path
                      id="Fill-8"
                      class="ign-logo__fill"
                      d="M85.2700547,17.0473089 L83.9576581,17.0473089 C82.244213,17.0473089 81.4192977,16.0646153 81.4192977,14.633808 L81.4192977,12.4845089 L85.2700547,12.4845089 L85.2700547,13.7574813 L93.4521354,13.7574813 L93.4521354,10.3894226 C93.4521354,10.3894226 85.5646179,10.3894226 84.0669092,10.3894226 C82.5685091,10.3894226 81.4891354,9.38957309 81.4891354,8.00199878 L81.4891354,3.11735291 C81.4891354,1.63919511 82.6639309,0.594740061 84.0931848,0.594740061 C85.5217472,0.594740061 94.8219234,0.594740061 94.8219234,0.594740061 C96.2719212,0.594740061 97.2752339,1.66870336 97.2752339,3.22166116 C97.2752339,4.77256024 97.2752339,5.1849896 97.2752339,5.1849896 L93.4521354,5.1849896 L93.4521354,3.88456758 L85.2700547,3.88456758 L85.2700547,7.12498593 L94.6283138,7.12498593 C96.0098567,7.12498593 97.2752339,8.03219327 97.2752339,9.77867034 L97.2752339,14.4746006 C97.2752339,16.0742226 96.3811723,17.0473089 94.709215,17.0473089 C93.0372576,17.0473089 85.2700547,17.0473089 85.2700547,17.0473089"
                    />
                    <polyline
                      id="Fill-9"
                      class="ign-logo__fill"
                      points="100.970412 17.0473089 100.970412 0.592681346 104.900687 0.592681346 104.900687 7.17370887 112.387156 0.592681346 117.708655 0.592681346 108.77772 8.23600612 118.030185 17.0473089 112.520608 17.0473089 104.900687 9.56319144 104.900687 17.0473089 100.970412 17.0473089"
                    />
                  </g>
                  <g id="Star" fill-rule="nonzero">
                    <path
                      id="Shape"
                      d="M4.28463565,0 L31.3468062,0 C33.7169495,0 35.6383302,1.91076181 35.6383302,4.26780595 L35.6383302,33.132194 C35.6383302,35.4892382 33.7169495,37.4 31.3468062,37.4 L4.28463565,37.4 C1.91830905,37.4 0,35.4923151 0,33.1390665 L0,4.27467843 C-0.00365105909,3.142229 0.446140088,2.05490945 1.25005944,1.25285417 C2.0539788,0.450798892 3.14588678,0 4.28463565,0 Z"
                      fill="#42B0D5"
                    />
                    <polygon
                      id="Shape"
                      fill="#FFFFFF"
                      points="23.4962889 17.6509756 30.5313476 8.91442683 30.5106156 8.88706098 20.3450249 13.7308171 17.8364529 2.84604878 17.7949889 2.84604878 15.2864169 13.7308171 5.12082631 8.88706098 5.10009431 8.91442683 12.135153 17.6509756 1.96956232 22.4947317 1.98338365 22.528939 13.2615916 22.528939 10.7530196 33.4205488 10.7806623 33.4342317 17.8157209 24.6976829 24.8507796 33.4342317 24.8853329 33.4137073 22.3698503 22.528939 33.6549689 22.528939 33.6618796 22.4947317"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
      <div
        v-click-outside="handleNavigationPanelClickOutside"
        class="
          ign-header__primary
          ign-header__primary--report
          ign-header__primary--icon
          ign-header__primary--push-s
          ign-header__primary--push-m
          ign-header__primary--push-l
          ign-track
        "
      >
        <div 
          v-if="customIcon" 
          class="ign-header__primary__wrapper"
        >
          <slot name="custom-icon"></slot>
        </div>
        <div 
          v-if="reportUrl"
          class="ign-header__primary__wrapper"
        >
        </div>
        <div 
          v-if="reportUrl"
          class="ign-header__primary__wrapper"
        >
          <a
            v-tooltip="reportName"
            :href="reportUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="
              ign-header__primary__link
              ign-track
              ign-header__primary__link--icon
            "
            title="Report"
            data-id="panel__navigation"
          >
            <span class="ign-icon mi-24px mi-chart-bars-vertical"></span>
          </a>
        </div>
      </div>
      <div
        v-click-outside="handleNavigationPanelClickOutside"
        class="
          ign-header__primary
          ign-header__primary--menu
          ign-header__primary--icon
          ign-header__primary--icon-s
          ign-header__primary--icon-m
        "
        @click="handleClick($event, 'open')"
      >
        <div class="ign-header__primary__wrapper">
          <a
            class="
              ign-header__primary__link
              ign-track
              ign-header__primary__link--icon
            "
            title="Menu"
            data-id="panel__navigation"
          >
            <span class="ign-icon mi-24px mi-bars-horizontal"></span>
          </a>
          <div
            id="panel__account"
            class="ign-header__panel ign-header__panel--account"
            :class="isPanelNavigationOpen ? 'ign-header__panel--open' : ''"
          >
            <button
              class="ign-header__panel__close"
              @click="handleClick($event, 'close')"
            >
              Close
              <span class="ign-icon mi-24px mi-times-circle"></span>
            </button>
            <div class="ign-header__account">
              <div v-if="user.displayName" class="ign-header__account__link">
                <div class="ign-header__account__link__label">Name</div>
                {{ user.displayName }}
                <span class="ign-icon mi-24px mi-user-circle"></span>
              </div>
              <div v-if="user.jobTitle" class="ign-header__account__link">
                <div class="ign-header__account__link__label">Job title</div>
                {{ user.jobTitle }}
              </div>
              <div v-if="user.mail" class="ign-header__account__link">
                <div class="ign-header__account__link__label">Username</div>
                {{ user.mail }}
              </div>
              <hr class="ign-header__hr" />
              <template v-if="panelStates.length">
                <div
                  v-for="item in panelStates"
                  :key="`${item.id}-${item.name}`"
                >
                  <a
                    class="
                      ign-header__account__link
                      ign-header__account__link--action
                      ign-header__account__link--href
                      ign-track
                    "
                    :title="item.name"
                    @click="handleClick($event, 'custom', item.emitName)"
                  >
                    {{ item.name }}
                    <span
                      :class="['ign-icon', 'mi-24px', `mi-${item.icon}`]"
                    ></span>
                  </a>
                  <hr class="ign-header__hr" />
                </div>
              </template>
              <a
                class="
                  ign-header__account__link
                  ign-header__account__link--action
                  ign-header__account__link--href
                  ign-track
                "
                title="Log out"
                @click="handleClick($event, 'signOut')"
              >
                Log out
                <span class="ign-icon mi-24px mi-door-arrow-right"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
// Directives
import ClickOutside from "vue-click-outside";

// Helpers
import { debounce } from "../../utils/helpers";

export default {
  name: "Header",
  directives: {
    ClickOutside,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    panelStates: {
      type: Array,
      default: () => [],
    },
    reportUrl: {
      type: String,
      default: "",
    },
    reportName: {
      type: String,
      default: ""
    },
    customIcon: {
      type: Boolean,
      default: false,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isHoverOnBook: false,
      isPanelNavigationOpen: false,
    };
  },
  methods: {
    handleNavigationPanelClickOutside() {
      this.isPanelNavigationOpen = false;
    },
    handleClick(event, type, emitName) {
      event.stopPropagation();
      this.action = type;
      this.debounceClick(type, emitName);
    },
    debounceClick: debounce(async function (type, emitName) {
      switch (type) {
        case "close":
          this.isPanelNavigationOpen = false;
          return;
        case "open":
          this.isPanelNavigationOpen = true;
          return;
        case "signOut":
          this.$emit("signOut");
          return;
        case "custom":
          this.isPanelNavigationOpen = false;
          return this.$emit(emitName);
        default:
          return;
      }
    }, 200),
  },
};
</script>

<style lang="scss" scoped>
.ign-header__promo:after {
  content: "";
  clear: both;
  display: table;
}
.ign-button,
.ign-footer,
.ign-header,
.ign-header__login__input,
.ign-header__menu__link,
.ign-header__panel__menu__link,
.ign-header__search__input {
  font-family: Maersk Text, -apple-system, BlinkMacSystemFont,
    Microsoft JhengHei, Microsoft Yahei, 微软雅黑, STXihei, 华文细黑, sans-serif;
  font-size: 16px;
  line-height: 22px;
}
.ign-banner,
.ign-button--small,
.ign-header--beta .ign-header__logo:after,
.ign-header--beta .ign-header__panel--navigation:before,
.ign-header__form__message,
.ign-header__form__message a,
.ign-header__form__message button,
.ign-header__search__results__result__url,
.ign-tag {
  font-family: Maersk Text, -apple-system, BlinkMacSystemFont,
    Microsoft JhengHei, Microsoft Yahei, 微软雅黑, STXihei, 华文细黑, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
}
.ign-header__panel__link {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
}
.ign-header__panel__link,
.ign-header__primary__link {
  font-family: Maersk Text, -apple-system, BlinkMacSystemFont,
    Microsoft JhengHei, Microsoft Yahei, 微软雅黑, STXihei, 华文细黑, sans-serif;
}
.ign-header__primary__link {
  font-size: 16px;
  line-height: 22px;
}
.ign-header__menu__link--subheading,
.ign-header__panel__close,
.ign-header__panel__language,
.ign-header__panel__menu__close,
.ign-header__panel__menu__link--subheading {
  font-family: Maersk Headline, -apple-system, BlinkMacSystemFont,
    Microsoft JhengHei, Microsoft Yahei, 微软雅黑, STXihei, 华文细黑, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  margin: 0;
}
.ign-header__panel__link--heading,
.ign-header__panel__primary__link,
.ign-header__promo__title,
.ign-header__search__results__result__title,
.ign-header__search__start__heading {
  font-family: Maersk Headline, -apple-system, BlinkMacSystemFont,
    Microsoft JhengHei, Microsoft Yahei, 微软雅黑, STXihei, 华文细黑, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin: 0;
}
.ign-header__title {
  font-family: Maersk Headline, -apple-system, BlinkMacSystemFont,
    Microsoft JhengHei, Microsoft Yahei, 微软雅黑, STXihei, 华文细黑, sans-serif;
  font-size: 30px;
  font-weight: 500;
  line-height: 32px;
  margin: 0;
}
.ign-push,
.ign-push body {
  height: 100%;
}
.ign-push body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.ign-push main {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
}
.ign-button {
  display: inline-block;
  background: #00233d;
  color: #fff;
  border: 2px solid rgba(0, 0, 0, 0);
  text-decoration: none;
  padding: 8px 20px;
  cursor: pointer;
  border-radius: 2px;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.ign-button:hover {
  background: #003d6d;
  color: #fff;
  -webkit-box-shadow: 0 3px 4px 0 rgba(20, 20, 20, 0.03),
    0 3px 3px -2px rgba(20, 20, 20, 0.03), 0 1px 8px 0 rgba(20, 20, 20, 0.04);
  box-shadow: 0 3px 4px 0 rgba(20, 20, 20, 0.03),
    0 3px 3px -2px rgba(20, 20, 20, 0.03), 0 1px 8px 0 rgba(20, 20, 20, 0.04);
}
.ign-button:focus {
  background: #003d6d;
  color: #fff;
  -webkit-box-shadow: inset 0 0 0 2px #fff;
  box-shadow: inset 0 0 0 2px #fff;
  outline: none;
}
.ign-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ign-button--block {
  width: 100%;
  text-align: center;
}
.ign-button--muted {
  border-color: #00233d;
  color: #00233d;
  background: rgba(0, 0, 0, 0);
}
.ign-button--muted:hover {
  border: 2px solid rgba(0, 0, 0, 0);
}
.ign-button--small {
  padding: 5px 15px;
}

@font-face {
  font-family: Maersk Text;
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://assets.maerskline.com/sharedfonts/maeu/text/MaerskText-Regular.eot)
      format("eot"),
    url(https://assets.maerskline.com/sharedfonts/maeu/text/MaerskText-Regular.woff2)
      format("woff2"),
    url(https://assets.maerskline.com/sharedfonts/maeu/text/MaerskText-Regular.woff)
      format("woff");
}
@font-face {
  font-family: Maersk Text;
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(https://assets.maerskline.com/sharedfonts/maeu/text/MaerskText-Light.eot)
      format("eot"),
    url(https://assets.maerskline.com/sharedfonts/maeu/text/MaerskText-Light.woff2)
      format("woff2"),
    url(https://assets.maerskline.com/sharedfonts/maeu/text/MaerskText-Light.woff)
      format("woff");
}
@font-face {
  font-family: Maersk Headline;
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://assets.maerskline.com/sharedfonts/maeu/headline/MaerskHeadline-Regular.eot)
      format("eot"),
    url(https://assets.maerskline.com/sharedfonts/maeu/headline/MaerskHeadline-Regular.woff2)
      format("woff2"),
    url(https://assets.maerskline.com/sharedfonts/maeu/headline/MaerskHeadline-Regular.woff)
      format("woff");
}
@font-face {
  font-family: Maersk Headline;
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(https://assets.maerskline.com/sharedfonts/maeu/headline/MaerskHeadline-Light.eot)
      format("eot"),
    url(https://assets.maerskline.com/sharedfonts/maeu/headline/MaerskHeadline-Light.woff2)
      format("woff2"),
    url(https://assets.maerskline.com/sharedfonts/maeu/headline/MaerskHeadline-Light.woff)
      format("woff");
}
.ign-header,
.ign-header * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.ign-lock {
  overflow-x: visible;
  overflow-x: initial;
}
.ign-lock,
.ign-lock body {
  overflow: hidden;
}
.ign-header {
  display: block !important;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  height: 62px;
  z-index: 100;
  color: #141414;
  padding: 0 16px;
  &__full-width {
    padding: 0 48px;
  }
}
.ign-lock .ign-header {
  z-index: 1001;
}
@media (min-width: 700px) {
  .ign-header {
    padding: 0 24px;
    &__full-width {
      padding: 0 48px;
    }
  }
}
@media (min-width: 1000px) {
  .ign-header {
    height: 86px;
  }
}
.ign-header:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: -1;
  -webkit-transition: -webkit-transform 0.4s;
  transition: -webkit-transform 0.4s;
  transition: transform 0.4s;
  transition: transform 0.4s, -webkit-transform 0.4s;
  border-bottom: 1px solid #ededed;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
}
.ign-header--hidden {
  -webkit-transform: translateY(-100%);
  -ms-transform: translateY(-100%);
  transform: translateY(-100%);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.ign-header .ign-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.ign-header .ign-icon__fill {
  fill: #141414;
}
.ign-header__hr {
  height: 0;
  background: rgba(0, 0, 0, 0);
  border: 0;
  border-bottom: 2px solid #ededed;
  margin: 20px 0;
}
.ign-header__container {
  max-width: 1280px;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 62px;
  &__full-width {
    max-width: unset;
    margin: unset;
  }
}
@media (min-width: 1000px) {
  .ign-header__container {
    height: 86px;
    &__full-width {
      max-width: unset;
      margin: unset;
    }
  }
}
.ign-spread .ign-header__container {
  max-width: none;
}
.ign-header__skeleton-item {
  margin: 0 15px 0 25px;
  width: 50px;
  height: 24px;
  background: #ededed;
  border-radius: 20px;
  text-indent: -12000px;
}
@media (min-width: 0px) and (max-width: 1199px) {
  .ign-header__skeleton-item--line {
    display: none;
  }
}
.ign-header__skeleton-item--long {
  width: 75px;
}
.ign-header__skeleton-item--icon {
  width: 24px;
  margin: 0 0 0 16px;
}
@media (min-width: 1000px) {
  .ign-header__skeleton-item--icon {
    margin-left: 34px;
  }
}
.ign-header__error,
.ign-header__skeleton-item--push {
  margin-left: auto;
}
.ign-header__error__label {
  -webkit-transition: color 0.2s;
  transition: color 0.2s;
}
@media (min-width: 0px) and (max-width: 699px) {
  .ign-header__error__label {
    display: none;
  }
}
.ign-header__error .ign-button {
  margin-left: 15px;
}
.ign-header--transparent .ign-header__error {
  color: #fff;
}
.ign-header__primary {
  display: none;
}
.ign-header__primary--icon {
  display: flex;
}
@media (min-width: 1200px) {
  .ign-header__primary,
  .ign-header__primary--language {
    display: flex;
  }
}
@media (min-width: 0px) and (max-width: 699px) {
  .ign-header__primary--push-s {
    margin-left: auto;
  }
}
@media (min-width: 700px) and (max-width: 1199px) {
  .ign-header__primary--push-m {
    margin-left: auto;
  }
}
@media (min-width: 1200px) {
  .ign-header__primary--push-l {
    margin-left: auto;
  }
}
.ign-header__primary__wrapper {
  position: relative;
}
.ign-header__primary__link {
  text-decoration: none;
  padding: 10px 15px;
  display: block;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-transition: color 0.2s;
  transition: color 0.2s;
  color: #141414;
  cursor: pointer;
}
.ign-header__primary__link:after {
  content: "";
  position: absolute;
  bottom: 6px;
  left: 15px;
  right: 15px;
  height: 1px;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  background: #141414;
  opacity: 0;
}
.ign-header__primary__link:hover {
  color: #141414;
}
.ign-header__primary__link--dropdown {
  padding-right: 28px;
}
.ign-header__primary__link--dropdown:after {
  right: 24px;
}
.ign-header__primary__link--icon {
  padding: 0 7px;
  height: 24px;
}
@media (min-width: 700px) {
  .ign-header__primary__link--icon {
    padding: 0 15px;
  }
}
.ign-header__primary__link--icon:after {
  display: none;
}
.ign-header__primary__link .ign-icon__fill {
  fill: #141414;
  -webkit-transition: fill 0.2s;
  transition: fill 0.2s;
}
.ign-header__primary__link .ign-icon__stroke {
  stroke: #141414;
  -webkit-transition: stroke 0.2s;
  transition: stroke 0.2s;
}
.ign-header__primary__link--dropdown .ign-icon {
  position: absolute;
  top: calc(50% + 2px);
  right: 8px;
  width: 20px;
  height: 20px;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.ign-header__primary:last-child .ign-header__primary__link {
  padding-right: 0;
}
.ign-header__primary__link:hover:after,
.ign-header__primary__wrapper--active .ign-header__primary__link:after {
  opacity: 1;
}
.ign-header--transparent .ign-header__primary__link:after {
  background-color: #fff;
}
.ign-header__logo {
  -webkit-transition: width 0.3s;
  transition: width 0.3s;
}
.ign-header__logo .ign-logo {
  height: auto;
  display: block;
  width: 140px;
  max-height: 45px;
}
.ign-header__logo .ign-logo__fill {
  fill: #141414;
  -webkit-transition: fill 0.2s;
  transition: fill 0.2s;
}
@media (min-width: 700px) {
  .ign-header__logo {
    margin-right: 12px;
  }
  .ign-header__logo .ign-logo {
    width: 175px;
  }
}
.ign-header--beta .ign-header__logo:after {
  display: none;
  content: "Beta";
  position: absolute;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-decoration: underline;
  border-radius: 20px;
  border: 1px solid #141414;
  color: #141414;
  padding: 4px 12px 5px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
@media (min-width: 700px) {
  .ign-header--beta .ign-header__logo:after {
    font-size: 16px;
  }
}
@media (min-width: 360px) {
  .ign-header--beta .ign-header__logo {
    padding-right: 65px;
    position: relative;
  }
  .ign-header--beta .ign-header__logo:after {
    display: block;
  }
}
@media (min-width: 700px) {
  .ign-header--beta .ign-header__logo {
    padding-right: 75px;
  }
}
.ign-header--beta .ign-header__logo:after {
  text-decoration: none;
}
.ign-header--transparent {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#282828),
    to(rgba(40, 40, 40, 0))
  );
  background: linear-gradient(180deg, #282828, rgba(40, 40, 40, 0));
}
.ign-header--transparent:before {
  -webkit-transform: scaleY(0);
  -ms-transform: scaleY(0);
  transform: scaleY(0);
}
.ign-header--transparent .ign-header__logo:after {
  color: #fff;
  border-color: #fff;
}
.ign-header--transparent .ign-header__primary__link {
  color: hsla(0, 0%, 100%, 0.9);
}
.ign-header--transparent .ign-header__primary__link:hover {
  color: #fff;
}
.ign-header--transparent .ign-header__primary .ign-icon__fill {
  fill: #fff;
}
.ign-header--transparent .ign-header__primary .ign-icon__stroke {
  stroke: #fff;
}
.ign-header--transparent .ign-header__skeleton-item {
  background-color: hsla(0, 0%, 100%, 0.1);
}
.ign-header--transparent .ign-header__logo .ign-logo__fill {
  fill: #fff;
}
.ign-header__menu {
  background: #fff;
  color: #141414;
  border-radius: 2px;
  -webkit-box-shadow: 0 0 50px rgba(20, 20, 20, 0.1);
  box-shadow: 0 0 50px rgba(20, 20, 20, 0.1);
  position: absolute;
  top: 100%;
  left: 0;
  padding: 16px;
  width: 320px;
  visibility: hidden;
  opacity: 0;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;

  &.account-dropdown {
    width: 200px;
    left: unset;
    right: -40px;

    @media (max-width: 600px) {
      right: -32px;
    }
  }
}
.ign-header__menu--open {
  visibility: visible;
  opacity: 1;
}
.ign-header__menu--right {
  left: auto;
  right: 0;
}
.ign-header__menu__close {
  position: absolute;
  top: 28px;
  right: 28px;
  padding: 0;
  margin: 0;
  border: 0;
  background: none;
  z-index: 1;
}
@media (min-width: 1200px) {
  .ign-header__menu__close {
    display: none;
  }
}
.ign-header__menu__link {
  color: #141414;
  text-decoration: none;
  padding: 0;
  display: block;
  position: relative;
  cursor: pointer;
  border: 0;
  background-color: rgba(0, 0, 0, 0);

  & img {
    height: 40px;
    width: 40px;
  }

  &.account-dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.ign-header__menu__link:hover {
  color: #141414;
  text-decoration: underline;
}
.ign-header__menu__link--active {
  color: #0073ab;
  text-decoration: underline;
}
.ign-header__menu__link--active:hover {
  color: #0073ab;
}
.ign-header__menu__link--subheading {
  cursor: default;
}
.ign-header__menu__link--subheading:hover {
  text-decoration: none;
}
.ign-header__menu__link + .ign-header__menu__link {
  margin-top: 8px;
}
.ign-header__menu__link + .ign-header__menu__link--subheading {
  margin-top: 24px;
}
.ign-header__menu__badge {
  position: absolute;
  top: 0;
  right: 1px;
  font-style: normal;
  background: #00243d;
  color: #fff;
  width: 24px;
  height: 24px;
  line-height: 22px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
}
.ign-header .ign-delay {
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  opacity: 0;
}
.ign-header .ign-delay--1 {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}
.ign-header .ign-delay--2 {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
.ign-header .ign-delay--3 {
  -webkit-transition-delay: 0.3s;
  transition-delay: 0.3s;
}
.ign-header .ign-delay--4 {
  -webkit-transition-delay: 0.4s;
  transition-delay: 0.4s;
}
.ign-header .ign-delay--5 {
  -webkit-transition-delay: 0.5s;
  transition-delay: 0.5s;
}
.ign-header__panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  color: #141414;
  -webkit-box-shadow: 0 0 50px rgba(20, 20, 20, 0.1);
  box-shadow: 0 0 50px rgba(20, 20, 20, 0.1);
  padding: 80px 16px 0;
  width: 100%;
  visibility: hidden;
  opacity: 0;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-transform: translateX(100px);
  -ms-transform: translateX(100px);
  transform: translateX(100px);
  z-index: 102;
  overflow: auto;
  overflow-x: hidden;
}
.ign-header__panel:after {
  content: "";
  display: block;
  height: 16px;
}
@media (min-width: 700px) {
  .ign-header__panel {
    padding: 90px 84px 0;
    width: 780px;
    -webkit-transform: translateX(100px);
    -ms-transform: translateX(100px);
    transform: translateX(100px);
  }
  .ign-header__panel:after {
    height: 80px;
  }
}
@media (min-width: 1200px) {
  .ign-header__panel {
    padding: 90px 104px 0;
    width: 917px;
  }
}
.ign-header__panel--search {
  padding-top: 16px;
}
.ign-header__panel--locked {
  overflow: hidden;
}
.ign-header__panel--open {
  visibility: visible;
}
.ign-header__panel--open,
.ign-header__panel--open .ign-delay {
  opacity: 1;
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
}
.ign-header__panel__close {
  position: absolute;
  top: 24px;
  right: 16px;
  border: 0;
  padding: 0;
  background: none;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #141414;
}
.ign-header__panel__close .ign-icon {
  cursor: pointer;
}
@media (min-width: 700px) {
  .ign-header__panel__close {
    top: 24px;
    right: 84px;
  }
}
@media (min-width: 1200px) {
  .ign-header__panel__close {
    right: 104px;
  }
}
.ign-header__panel__close .ign-icon {
  margin-left: 10px;
}
.ign-header__panel__link {
  color: #141414;
  display: block;
  text-decoration: none;
}
.ign-header__panel__link:hover {
  color: #141414;
  text-decoration: underline;
}
.ign-header__panel__link + .ign-header__panel__link {
  margin-top: 8px;
}
.ign-header__panel__link--heading {
  margin-bottom: 6px;
  color: #141414;
}
.ign-header__panel__link--heading:hover {
  color: #141414;
}
@media (min-width: 0px) and (max-width: 699px) {
  .ign-header__panel__columns__column + .ign-header__panel__columns__column {
    margin-top: 36px;
  }
}
@media (min-width: 700px) {
  .ign-header__panel__columns {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 -20px;
  }
  .ign-header__panel__columns__column {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 0 20px;
  }
}
.ign-header__panel__list + .ign-header__panel__list {
  margin-top: 28px;
}
.ign-header__panel__primary {
  margin-bottom: 32px;
}
@media (min-width: 0px) and (max-width: 1199px) {
  .ign-header__panel__primary {
    padding-bottom: 24px;
    border-bottom: 1px solid #ededed;
  }
}
@media (min-width: 700px) and (max-width: 1199px) {
  .ign-header__panel__primary {
    margin-bottom: 40px;
    padding-bottom: 32px;
  }
}
@media (min-width: 1200px) {
  .ign-header__panel__primary {
    display: none;
  }
}
.ign-header__panel__primary__link {
  position: relative;
  display: block;
  color: #141414;
  text-decoration: none;
  margin-bottom: 8px;
  padding-right: 35px;
}
.ign-header__panel__primary__link:last-child {
  margin-bottom: 0;
}
.ign-header__panel__primary__link:hover {
  text-decoration: underline;
  color: #141414;
}
.ign-header__panel__primary__link .ign-icon {
  position: absolute;
  right: 0;
  top: 2px;
}
.ign-header__panel__primary__link .ign-icon__fill {
  fill: #141414;
}
.ign-header__panel__language {
  position: absolute;
  top: 24px;
  left: 16px;
  display: block;
  border: 0;
  background: none;
  color: #141414;
  text-decoration: none;
  padding: 0 25px 0 0;
}
.ign-header__panel__language:hover {
  color: #141414;
}
@media (min-width: 700px) {
  .ign-header__panel__language {
    top: 24px;
    left: 84px;
  }
}
@media (min-width: 1200px) {
  .ign-header__panel__language {
    left: 104px;
    display: none;
  }
}
.ign-header__panel__language .ign-icon {
  position: absolute;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
}
.ign-header__panel__language .ign-icon__fill {
  fill: #141414;
}
.ign-header__panel__menu {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 80px 16px 20px;
  background: #fff;
  z-index: 1;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  visibility: hidden;
  opacity: 0;
  overflow: auto;
}
@media (min-width: 700px) {
  .ign-header__panel__menu {
    padding: 84px 84px 20px;
  }
}
@media (min-width: 1200px) {
  .ign-header__panel__menu {
    padding-left: 104px;
    padding-right: 104px;
  }
}
.ign-header__panel__menu--open {
  visibility: visible;
  opacity: 1;
}
@media (min-width: 1200px) {
  .ign-header__panel__menu {
    display: none !important;
  }
}
.ign-header__panel__menu__close {
  position: absolute;
  top: 24px;
  right: 16px;
  padding: 0;
  margin: 0;
  border: 0;
  background-color: rgba(0, 0, 0, 0);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
@media (min-width: 700px) {
  .ign-header__panel__menu__close {
    right: 84px;
  }
}
.ign-header__panel__menu__close .ign-icon {
  margin-left: 10px;
}
.ign-header__panel__menu__link {
  display: block;
  color: #141414;
  text-decoration: none;
  position: relative;
  padding: 0;
  border: 0;
  background-color: rgba(0, 0, 0, 0);
}
.ign-header__panel__menu__link:hover {
  color: #141414;
}
.ign-header__panel__menu__link + .ign-header__panel__menu__link {
  margin-top: 12px;
}
.ign-header__panel__menu__link--active {
  color: #0073ab;
  text-decoration: underline;
}
.ign-header__panel__menu__link--subheading {
  cursor: default;
}
.ign-header__panel__menu__link--subheading:hover {
  text-decoration: none;
}
.ign-header__panel__menu__link + .ign-header__panel__menu__link--subheading {
  margin-top: 24px;
}
.ign-header__panel__menu__badge {
  position: absolute;
  top: 0;
  right: 1px;
  font-style: normal;
  background: #00243d;
  color: #fff;
  width: 24px;
  height: 24px;
  line-height: 22px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
}
.ign-header--beta .ign-header__panel--navigation:before {
  display: none;
  content: "Beta";
  position: absolute;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-decoration: underline;
  border-radius: 20px;
  border: 1px solid #141414;
  color: #141414;
  padding: 4px 12px 5px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
@media (min-width: 700px) {
  .ign-header--beta .ign-header__panel--navigation:before {
    font-size: 16px;
  }
}
@media (min-width: 0px) and (max-width: 359px) {
  .ign-header--beta .ign-header__panel--navigation:before {
    display: block;
    -webkit-transform: none;
    -ms-transform: none;
    transform: none;
    top: 26px;
    left: 16px;
    right: auto;
    text-decoration: none;
  }
}
@media (min-width: 0px) and (max-width: 359px) {
  .ign-header--beta .ign-header__panel__language {
    left: 85px;
  }
}
.ign-header__account {
  margin: 0 20px 0 40px;
}
@media (min-width: 700px) {
  .ign-header__account {
    margin: 0;
  }
}
.ign-header__account__link {
  display: block;
  text-decoration: none;
  color: #141414;
  position: relative;
}
.ign-header__account__link--action {
  cursor: pointer;
}
.ign-header__account__link:hover {
  color: #141414;
}
.ign-header__account__link + .ign-header__account__link {
  margin-top: 20px;
}
.ign-header__account__link--href:hover {
  text-decoration: underline;
}
.ign-header__account__link__label {
  color: #878787;
  margin-bottom: 2px;
}
.ign-header__account__link .ign-icon {
  position: absolute;
  top: -1px;
  left: -38px;
}
.ign-header__account__link .ign-icon__fill {
  fill: #141414;
}
.ign-header__search__header {
  position: relative;
  border-radius: 20px;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  margin: 0 110px 32px 0;
  background-color: rgba(0, 0, 0, 0);
}
@media (min-width: 700px) {
  .ign-header__search__header {
    margin-bottom: 64px;
  }
}
.ign-header__search__clear {
  position: absolute;
  top: 12px;
  right: 16px;
  border: 0;
  padding: 0;
  background-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  display: none;
}
.ign-header__search__clear--open {
  display: block;
}
.ign-header__search__icon {
  position: absolute;
  top: 12px;
  left: 16px;
  z-index: -1;
}
.ign-header__search__input {
  width: 100%;
  padding: 12px 20px 12px 50px;
  border-radius: 25px;
  color: #141414;
  overflow: hidden;
  background: rgba(0, 0, 0, 0);
  border: 1px solid #ededed;
  -webkit-transition: border-color 0.2s;
  transition: border-color 0.2s;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-appearance: none;
}
.ign-header__search__input:focus {
  outline: none;
  border-color: #cfcfcf;
}
.ign-header__search__input::-ms-clear {
  display: none;
}
.ign-header__search__start--hidden {
  display: none;
}
.ign-header__search__start__heading {
  margin-bottom: 12px;
}
.ign-header__search__start__link {
  color: #141414;
  text-decoration: none;
  display: block;
}
.ign-header__search__start__link:hover {
  color: #141414;
  text-decoration: underline;
}
.ign-header__search__start__link + .ign-header__search__start__link {
  margin-top: 12px;
}
.ign-header__search__start__list {
  position: relative;
}
.ign-header__search__start__list + .ign-header__search__start__list {
  margin-top: 32px;
}
.ign-header__search__start__icon {
  position: absolute;
  top: 0;
  left: 0;
}
.ign-header__search__empty,
.ign-header__search__error,
.ign-header__search__skeleton {
  display: none;
}
.ign-header__search__empty--open,
.ign-header__search__error--open,
.ign-header__search__skeleton--open {
  display: block;
}
.ign-header__search__empty,
.ign-header__search__error {
  margin-bottom: 20px;
}
.ign-header__search__skeleton__total {
  height: 20px;
  background: #ededed;
  border-radius: 5px;
  max-width: 150px;
  margin-bottom: 24px;
  margin-left: auto;
}
.ign-header__search__skeleton__line {
  height: 20px;
  background: #ededed;
  border-radius: 5px;
  max-width: 90%;
}
.ign-header__search__skeleton__line--large {
  height: 30px;
  max-width: 70%;
}
.ign-header__search__skeleton__line--short {
  max-width: 50%;
}
.ign-header__search__skeleton__line + .ign-header__search__skeleton__line {
  margin-top: 12px;
}
.ign-header__search__skeleton__item + .ign-header__search__skeleton__item {
  margin-top: 32px;
}
.ign-header__search__results {
  display: none;
}
.ign-header__search__results--open {
  display: block;
}
.ign-header__search__results__total {
  text-align: right;
  color: #141414;
  margin-bottom: 24px;
}
.ign-header__search__results__all {
  display: block;
  padding: 8px 0;
  width: 100%;
  border-radius: 2px;
  text-align: center;
  text-decoration: none;
  margin-top: 32px;
  border: 2px solid #ededed;
  color: #141414;
  background-color: rgba(0, 0, 0, 0);
  -webkit-transition: border-color 0.2s;
  transition: border-color 0.2s;
}
.ign-header__search__results__all:hover {
  border-color: #cfcfcf;
  color: #141414;
  background-color: rgba(0, 0, 0, 0);
}
.ign-header__search__results__result {
  display: block;
  text-decoration: none;
  color: #141414;
}
.ign-header__search__results__result + .ign-header__search__results__result {
  margin-top: 32px;
}
.ign-header__search__results__result__title {
  margin-bottom: 4px;
  color: #141414;
}
.ign-header__search__results__result__url {
  color: #0073ab;
  margin-bottom: 8px;
}
.ign-header__search__results__result:hover
  .ign-header__search__results__result__url {
  text-decoration: underline;
}
.ign-header__form {
  margin-bottom: 40px;
}
.ign-header__form__intro {
  margin-bottom: 20px;
}
.ign-header__form__message {
  display: none;
  color: #b80012;
  margin-bottom: 20px;
}
.ign-header__form__message--open {
  display: block;
}
.ign-header__form__message a,
.ign-header__form__message button {
  color: #141414;
  clear: both;
  display: inline-block;
  margin: 4px 0 0;
  border: 0;
  background: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
}
.ign-header__form__message a:hover,
.ign-header__form__message button:hover {
  text-decoration: none;
}
.ign-header__fieldset {
  position: relative;
  padding: 0 0 0 35px;
  border: 0;
  display: block;
}
.ign-header__fieldset--left {
  padding-left: 0;
}
.ign-header__fieldset + .ign-header__fieldset {
  margin-top: 32px;
}
.ign-header__fieldset__icon {
  position: absolute;
  bottom: 3px;
  left: 0;
  width: 24px;
}
.ign-header__fieldset a {
  color: #141414;
}
.ign-header__fieldset a:hover {
  text-decoration: none;
}
.ign-header__title {
  margin-bottom: 24px;
}
.ign-header__buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.ign-header__label {
  position: absolute;
  top: 0;
  left: 35px;
  color: #878787;
  opacity: 0;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  z-index: -1;
}
.ign-header__login {
  display: none;
}
.ign-header__login--open {
  display: block;
}
.ign-header__login__timer {
  display: none;
  padding-left: 35px;
  position: relative;
}
.ign-header__login__timer--open {
  display: inline-block;
}
.ign-header__login__timer .ign-icon {
  position: absolute;
  top: 50%;
  left: 5px;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.ign-header__login__input {
  width: 100%;
  padding: 12px 0 8px;
  border: 0;
  border-bottom: 2px solid #ededed;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  background: rgba(0, 0, 0, 0);
  color: #141414;
}
.ign-header__login__input:focus {
  outline: none;
  border-color: #141414;
}
.ign-header__login__input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ign-header__login__input:-webkit-autofill,
.ign-header__login__input:-webkit-autofill:active,
.ign-header__login__input:-webkit-autofill:focus,
.ign-header__login__input:-webkit-autofill:hover {
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
@media (min-width: 700px) {
  .ign-header__login__input {
    width: 50%;
  }
  .ign-header__login__input--code {
    width: 200px;
  }
}
.ign-header__login__azure,
.ign-header__login__submit--hidden {
  display: none;
}
.ign-header__login__azure--open {
  display: block;
}
.ign-header__label--lock,
.ign-header__login__input:focus + .ign-header__label {
  top: -10px;
  font-size: 14px;
  opacity: 1;
}
.ign-header__promo {
  margin-top: 36px;
  padding: 16px;
  max-width: 604px;
  background: #f7f7f7;
  color: #141414;
}
@media (min-width: 700px) {
  .ign-header__promo {
    padding: 32px;
  }
}
.ign-header__promo--hidden {
  opacity: 0;
  visibility: hidden;
}
.ign-header__promo__title {
  color: #141414;
  margin-bottom: 8px;
}
.ign-header__promo__text {
  margin: 0 0 16px;
}
.ign-header__promo__img {
  max-width: 100%;
  margin: 0 auto 16px;
}
@media (min-width: 700px) {
  .ign-header__promo__img {
    width: 160px;
    float: right;
    margin: 0 0 0 32px;
  }
}
.ign-header__mask {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(20, 20, 20, 0.75);
  visibility: hidden;
  opacity: 0;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.ign-header__mask--open {
  visibility: visible;
  opacity: 1;
}
.ign-header__skip {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.ign-header__skip:focus {
  display: block;
  opacity: 1;
  z-index: 1;
  width: 100%;
  height: auto;
  line-height: 86px;
  height: 86px;
  background: #f7f7f7;
  color: #0073ab;
  text-align: center;
  outline: none;
}
.ign-tag {
  display: inline-block;
  text-align: center;
  background: #42b0d5;
  color: #fff;
  border-radius: 15px;
  padding: 2px 8px;
  margin-left: 4px;
}
.ign-footer .ign-tag {
  background: #0073ab;
  color: #fff;
}
.ign-banner + .ign-header,
.ign-banner + .ign-header__skip {
  top: 40px;
}
@media print {
  .ign-header {
    display: none !important;
  }
  #main,
  .ign-with-banner #main {
    margin-top: 0 !important;
  }
}
.ign-footer,
.ign-footer * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.ign-footer {
  margin-top: auto;
  padding: 46px 16px 80px;
  background: #f7f7f7;
  color: #141414;
}
.ign-footer a {
  color: #141414;
  text-decoration: none;
}
.ign-footer a:hover {
  text-decoration: underline;
}
.ign-footer__container {
  max-width: 1280px;
  margin: 0 auto;
}
.ign-footer__base {
  margin-top: 32px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.ign-footer__social__link {
  display: inline-block;
  color: #141414;
  text-decoration: none;
  padding: 0;
}
.ign-footer__social__link:hover {
  text-decoration: underline;
}
@media (min-width: 0px) and (max-width: 699px) {
  .ign-footer__links__column {
    border-bottom: 2px solid #ededed;
    margin-bottom: 40px;
    padding-bottom: 40px;
  }
  .ign-footer__base {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .ign-footer__copyright {
    margin-top: 48px;
    -webkit-box-ordinal-group: 3;
    -ms-flex-order: 2;
    order: 2;
  }
  .ign-footer__social {
    -webkit-box-ordinal-group: 2;
    -ms-flex-order: 1;
    order: 1;
  }
  .ign-footer__social__link {
    display: block;
  }
  .ign-footer__social__link + .ign-footer__social__link {
    margin-top: 12px;
  }
}
@media (min-width: 700px) {
  .ign-footer {
    padding: 80px 24px;
  }
  .ign-footer__links {
    -webkit-box-pack: space-evenly;
    -ms-flex-pack: space-evenly;
    justify-content: space-evenly;
    margin: 0 -24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .ign-footer__links__column {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 0 24px;
  }
  .ign-footer__base {
    margin-top: 64px;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
  }
  .ign-footer__copyright__text {
    margin-top: 16px;
  }
  .ign-footer__social {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: right;
  }
  .ign-footer__social__link {
    margin-left: 24px;
  }
}
.ign-footer__link {
  display: block;
}
.ign-footer__link + .ign-footer__link {
  margin-top: 12px;
}
.ign-footer .ign-logo {
  width: 170px;
  max-height: 40px;
}
.ign-footer .ign-logo__fill {
  fill: #141414;
}
@media print {
  .ign-footer {
    display: none !important;
  }
}
.ign-banner,
.ign-banner * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.ign-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #ffd029;
  color: #141414;
  z-index: 101;
  text-align: center;
  padding: 10px 16px 9px;
  cursor: pointer;
}
@media (min-width: 700px) {
  .ign-banner {
    padding-left: 24px;
    padding-right: 24px;
  }
}
.ign-banner--flop {
  min-height: 40px;
  height: auto;
  overflow: auto;
  white-space: normal;
}
.ign-banner .ign-icon {
  display: inline-block;
  vertical-align: middle;
  margin: -5px 6px 0 0;
  width: 20px;
}
.ign-banner .ign-icon__fill {
  fill: #141414;
}
.ign-banner a {
  color: #141414;
}
.ign-banner a:hover {
  text-decoration: none;
}
@media print {
  .ign-banner {
    display: none !important;
  }
}
</style>